function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M63.6612 147.767C66.9653 147.921 70.0062 149.39 73.4869 149.767C96.9186 152.309 120.67 152.309 144.101 149.767C155.111 148.576 165.832 146.307 176.92 145.774C188.298 145.222 200.086 146.163 211.047 143.116C224.147 139.472 233.631 129.932 234.161 119.86C234.668 110.256 227.857 101.345 224.2 92.1092C219.873 81.1504 219.99 69.3726 224.534 58.4706C229.101 47.5212 238.111 37.0906 237.266 25.6796C236.081 9.71092 211.855 -3.15995 190.238 0.685931C178.916 2.69785 169.418 8.33546 158.224 10.6852C140.042 14.507 120.507 9.17702 101.682 10.6852C85.6921 11.9943 70.9647 18.3136 60.2669 26.9465C49.5691 35.5794 42.664 46.3659 38.4917 57.5084C34.8117 67.3478 33.045 77.7543 26.1287 86.6496C21.0617 93.1619 13.2921 98.8026 11.0217 106.09C8.36042 114.629 0.462995 144.854 63.6612 147.767Z",
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.05,
  filter: "url(#filter0_f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M168.031 28.5154H43.2446C41.4109 28.5154 39.9243 30.1625 39.9243 32.1943V116.504H171.351V32.1943C171.351 31.2186 171.001 30.2828 170.378 29.5929C169.756 28.903 168.911 28.5154 168.031 28.5154H168.031Z",
  fill: "black"
}));

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M122.123 120.409H92.1351L93.1517 107.091H121.107L122.123 120.409Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M122.123 120.409H92.1351L93.1517 107.091H121.107L122.123 120.409Z",
  fill: "#DFEAF8"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.5,
  filter: "url(#filter1_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M46.8989 97.4552V108.981C46.8989 109.796 47.2202 110.578 47.7921 111.154C48.364 111.73 49.1397 112.054 49.9485 112.054H164.564C166.248 112.054 167.614 110.678 167.614 108.981V97.4552H46.8989Z",
  fill: "#ABADBE"
})));

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M124.206 118.745H90.8856V121.658H124.206V118.745Z",
  fill: "#DFEAF8"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.482 22.6057H50.1937C48.5143 22.6057 47.1528 23.9613 47.1528 25.6335V95.0221H167.522V25.6335C167.522 24.8305 167.202 24.0603 166.632 23.4925C166.062 22.9247 165.288 22.6057 164.482 22.6057Z",
  fill: "#06172D"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M47.1527 95.022V106.522C47.1527 107.335 47.4731 108.115 48.0434 108.69C48.6137 109.265 49.3872 109.589 50.1937 109.589H164.481C166.161 109.589 167.522 108.216 167.522 106.522V95.022H47.1527Z",
  fill: "#DFEAF8"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M164.482 22.6057H50.1937C48.5143 22.6057 47.1528 23.9613 47.1528 25.6335V91.0221C47.1528 93.2313 48.9437 95.0221 51.1528 95.0221H163.522C165.732 95.0221 167.522 93.2312 167.522 91.0221V25.6335C167.522 24.8305 167.202 24.0603 166.632 23.4925C166.062 22.9247 165.288 22.6057 164.482 22.6057H164.482Z",
  fill: "#C6D7EE"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M165.115 24.9169H49.9283V93.7913H165.115V24.9169Z",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M165.115 25.8413H78.1467V92.4045H165.115V25.8413Z",
  fill: "#DFEAF8"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M56.94 28.1098C57.2848 28.1098 57.5643 27.8303 57.5643 27.4855C57.5643 27.1407 57.2848 26.8612 56.94 26.8612C56.5952 26.8612 56.3157 27.1407 56.3157 27.4855C56.3157 27.8303 56.5952 28.1098 56.94 28.1098Z",
  fill: "#97A6BC"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M59.0225 28.1098C59.3673 28.1098 59.6468 27.8303 59.6468 27.4855C59.6468 27.1407 59.3673 26.8612 59.0225 26.8612C58.6778 26.8612 58.3983 27.1407 58.3983 27.4855C58.3983 27.8303 58.6778 28.1098 59.0225 28.1098Z",
  fill: "#97A6BC"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M61.1051 28.1098C61.4499 28.1098 61.7294 27.8303 61.7294 27.4855C61.7294 27.1407 61.4499 26.8612 61.1051 26.8612C60.7604 26.8612 60.4809 27.1407 60.4809 27.4855C60.4809 27.8303 60.7604 28.1098 61.1051 28.1098Z",
  fill: "#97A6BC"
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.4602 35.8139H58.0994L57.8283 35.4919C57.8202 35.4822 57.8081 35.4767 57.7954 35.4771H56.7004C56.5364 35.4787 56.4045 35.6121 56.4047 35.7759V37.7457C56.4047 37.9094 56.5366 38.0425 56.7004 38.0441H59.4602C59.624 38.0425 59.7559 37.9094 59.7559 37.7457V36.1124C59.7559 35.9487 59.624 35.8156 59.4602 35.8139Z",
  fill: "#97A6BC"
}));

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M60.966 36.4257C60.6677 36.4261 60.4262 36.5759 60.4262 36.7606C60.4262 36.9453 60.6677 37.0951 60.966 37.0955H67.4298C67.7281 37.0951 67.9696 36.9453 67.9696 36.7606C67.9696 36.5759 67.7281 36.4261 67.4298 36.4257H60.966Z",
  fill: "#97A6BC"
});

var _ref17 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.4602 31.1915H58.0994L57.8283 30.8694C57.8202 30.8597 57.8081 30.8543 57.7954 30.8547H56.7004C56.5364 30.8563 56.4045 30.9896 56.4047 31.1534V33.1233C56.4047 33.2869 56.5366 33.4201 56.7004 33.4217H59.4602C59.624 33.4201 59.7559 33.2869 59.7559 33.1233V31.4899C59.7559 31.3263 59.624 31.1931 59.4602 31.1915Z",
  fill: "#97A6BC"
}));

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M60.966 31.8033C60.6677 31.8036 60.4262 31.9535 60.4262 32.1382C60.4262 32.3229 60.6677 32.4727 60.966 32.473H67.4298C67.7281 32.4727 67.9696 32.3229 67.9696 32.1382C67.9696 31.9535 67.7281 31.8036 67.4298 31.8033H60.966Z",
  fill: "#97A6BC"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61.7732 40.4364H60.4123L60.1413 40.1143C60.1332 40.1046 60.121 40.0991 60.1084 40.0995H59.0133C58.8494 40.1012 58.7174 40.2345 58.7176 40.3983V42.3681C58.7176 42.5318 58.8495 42.6649 59.0133 42.6666H61.7732C61.937 42.6649 62.0689 42.5318 62.0689 42.3681V40.7348C62.0689 40.5711 61.937 40.438 61.7732 40.4364Z",
  fill: "#97A6BC"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M63.279 41.0482C62.9807 41.0485 62.7392 41.1983 62.7392 41.383C62.7392 41.5677 62.9807 41.7176 63.279 41.7179H69.7428C70.0411 41.7176 70.2826 41.5677 70.2826 41.383C70.2826 41.1983 70.0411 41.0485 69.7428 41.0482H63.279Z",
  fill: "#97A6BC"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip3)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.0862 45.0588H62.7253L62.4543 44.7367C62.4462 44.727 62.4341 44.7216 62.4214 44.722H61.3263C61.1624 44.7236 61.0305 44.8569 61.0306 45.0207V46.9906C61.0306 47.1542 61.1626 47.2874 61.3263 47.289H64.0862C64.25 47.2874 64.3819 47.1542 64.3819 46.9906V45.3572C64.3819 45.1936 64.25 45.0604 64.0862 45.0588Z",
  fill: "#97A6BC"
}));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M65.592 45.6706C65.2937 45.671 65.0521 45.8208 65.0521 46.0055C65.0521 46.1902 65.2937 46.34 65.592 46.3404H72.0557C72.354 46.34 72.5955 46.1902 72.5955 46.0055C72.5955 45.8208 72.354 45.671 72.0557 45.6706H65.592Z",
  fill: "#97A6BC"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip4)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.0862 49.6813H62.7253L62.4543 49.3592C62.4462 49.3495 62.4341 49.344 62.4214 49.3444H61.3263C61.1624 49.3461 61.0305 49.4794 61.0306 49.6432V51.613C61.0306 51.7767 61.1626 51.9098 61.3263 51.9115H64.0862C64.25 51.9098 64.3819 51.7767 64.3819 51.613V49.9797C64.3819 49.816 64.25 49.6829 64.0862 49.6813Z",
  fill: "#97A6BC"
}));

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M65.592 50.2931C65.2937 50.2934 65.0521 50.4432 65.0521 50.6279C65.0521 50.8126 65.2937 50.9625 65.592 50.9628H72.0557C72.354 50.9625 72.5955 50.8126 72.5955 50.6279C72.5955 50.4432 72.354 50.2934 72.0557 50.2931H65.592Z",
  fill: "#97A6BC"
});

var _ref25 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip5)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.0862 54.3037H62.7253L62.4543 53.9817C62.4462 53.9719 62.4341 53.9665 62.4214 53.9669H61.3263C61.1624 53.9685 61.0305 54.1018 61.0306 54.2656V56.2355C61.0306 56.3991 61.1626 56.5323 61.3263 56.5339H64.0862C64.25 56.5323 64.3819 56.3991 64.3819 56.2355V54.6022C64.3819 54.4385 64.25 54.3053 64.0862 54.3037Z",
  fill: "#97A6BC"
}));

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M65.592 54.9155C65.2937 54.9159 65.0521 55.0657 65.0521 55.2504C65.0521 55.4351 65.2937 55.5849 65.592 55.5853H72.0557C72.354 55.5849 72.5955 55.4351 72.5955 55.2504C72.5955 55.0657 72.354 54.9159 72.0557 54.9155H65.592Z",
  fill: "#97A6BC"
});

var _ref27 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip6)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.0862 58.9261H62.7253L62.4543 58.6041C62.4462 58.5944 62.4341 58.5889 62.4214 58.5893H61.3263C61.1624 58.5909 61.0305 58.7243 61.0306 58.8881V60.8579C61.0306 61.0216 61.1626 61.1547 61.3263 61.1563H64.0862C64.25 61.1547 64.3819 61.0216 64.3819 60.8579V59.2246C64.3819 59.0609 64.25 58.9278 64.0862 58.9261Z",
  fill: "#97A6BC"
}));

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M65.592 59.5379C65.2937 59.5383 65.0521 59.6881 65.0521 59.8728C65.0521 60.0575 65.2937 60.2073 65.592 60.2077H72.0557C72.354 60.2073 72.5955 60.0575 72.5955 59.8728C72.5955 59.6881 72.354 59.5383 72.0557 59.5379H65.592Z",
  fill: "#97A6BC"
});

var _ref29 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip7)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M64.0862 63.5486H62.7253L62.4543 63.2265C62.4462 63.2168 62.4341 63.2114 62.4214 63.2118H61.3263C61.1624 63.2134 61.0305 63.3467 61.0306 63.5105V65.4803C61.0306 65.644 61.1626 65.7772 61.3263 65.7788H64.0862C64.25 65.7772 64.3819 65.644 64.3819 65.4803V63.847C64.3819 63.6834 64.25 63.5502 64.0862 63.5486Z",
  fill: "#97A6BC"
}));

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M65.592 64.1604C65.2937 64.1607 65.0521 64.3106 65.0521 64.4953C65.0521 64.68 65.2937 64.8298 65.592 64.8301H72.0557C72.354 64.8298 72.5955 64.68 72.5955 64.4953C72.5955 64.3106 72.354 64.1607 72.0557 64.1604H65.592Z",
  fill: "#97A6BC"
});

var _ref31 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M84.3611 30.926C83.9946 30.9267 83.6979 31.237 83.6979 31.6194C83.6979 32.0018 83.9946 32.312 84.3611 32.3128H102.001C102.368 32.312 102.664 32.0018 102.664 31.6194C102.664 31.237 102.368 30.9267 102.001 30.926H84.3611Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.5406 30.4638C80.4959 30.465 80.4597 30.982 80.4597 31.6194C80.4597 32.2568 80.4959 32.7738 80.5406 32.775H82.6918C82.7365 32.7738 82.7727 32.2568 82.7727 31.6194C82.7727 30.982 82.7365 30.465 82.6918 30.4638H80.5406Z",
  fill: "#466089"
}));

var _ref32 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M84.3126 36.0107C83.9729 36.0114 83.6979 36.3216 83.6979 36.7041C83.6979 37.0865 83.9729 37.3967 84.3126 37.3974H100.662C101.002 37.3967 101.277 37.0865 101.277 36.7041C101.277 36.3216 101.002 36.0114 100.662 36.0107H84.3126Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M103.221 36.0107C102.658 36.0114 102.202 36.3216 102.202 36.7041C102.202 37.0865 102.658 37.3967 103.221 37.3974H130.326C130.889 37.3967 131.345 37.0865 131.345 36.7041C131.345 36.3216 130.889 36.0114 130.326 36.0107H103.221Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M132.837 36.0107C132.524 36.0114 132.271 36.3216 132.271 36.7041C132.271 37.0865 132.524 37.3967 132.837 37.3974H147.895C148.208 37.3967 148.461 37.0865 148.461 36.7041C148.461 36.3216 148.208 36.0114 147.895 36.0107H132.837Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M149.856 36.0107C149.597 36.0114 149.387 36.3216 149.387 36.7041C149.387 37.0865 149.597 37.3967 149.856 37.3974H162.333C162.592 37.3967 162.802 37.0865 162.802 36.7041C162.802 36.3216 162.592 36.0114 162.333 36.0107H149.856Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.5406 35.0862C80.4959 35.0874 80.4597 35.6045 80.4597 36.2419C80.4597 36.8792 80.4959 37.3963 80.5406 37.3975H82.6918C82.7365 37.3963 82.7727 36.8792 82.7727 36.2419C82.7727 35.6045 82.7365 35.0874 82.6918 35.0862H80.5406Z",
  fill: "#466089"
}));

var _ref33 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M88.9386 40.6331C88.599 40.6339 88.3239 40.9441 88.3239 41.3265C88.3239 41.7089 88.599 42.0192 88.9386 42.0199H105.288C105.628 42.0192 105.903 41.7089 105.903 41.3265C105.903 40.9441 105.628 40.6339 105.288 40.6331H88.9386Z",
  fill: "url(#paint1_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.9386 60.0474C88.599 60.0481 88.3239 60.3584 88.3239 60.7408C88.3239 61.1232 88.599 61.4334 88.9386 61.4342H105.288C105.628 61.4334 105.903 61.1232 105.903 60.7408C105.903 60.3584 105.628 60.0481 105.288 60.0474H88.9386Z",
  fill: "url(#paint2_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.8254 65.5944C88.5483 65.5951 88.3239 65.9053 88.3239 66.2877C88.3239 66.6702 88.5483 66.9804 88.8254 66.9811H102.163C102.44 66.9804 102.664 66.6702 102.664 66.2877C102.664 65.9053 102.44 65.5951 102.163 65.5944H88.8254Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M104.609 65.5944C104.046 65.5951 103.59 65.9053 103.59 66.2877C103.59 66.6702 104.046 66.9804 104.609 66.9811H131.714C132.277 66.9804 132.733 66.6702 132.733 66.2877C132.733 65.9053 132.277 65.5951 131.714 65.5944H104.609Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.729 70.2168C111.577 70.2175 111.454 70.5277 111.454 70.9102C111.454 71.2926 111.577 71.6028 111.729 71.6035H119.043C119.195 71.6028 119.318 71.2926 119.318 70.9102C119.318 70.5277 119.195 70.2175 119.043 70.2168H111.729Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.5399 74.8392C98.2628 74.84 98.0384 75.1502 98.0384 75.5326C98.0384 75.915 98.2628 76.2253 98.5399 76.226H111.877C112.155 76.2253 112.379 75.915 112.379 75.5326C112.379 75.1502 112.155 74.84 111.877 74.8392H98.5399Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M114.372 74.8392C113.782 74.84 113.304 75.1502 113.304 75.5326C113.304 75.915 113.782 76.2253 114.372 76.226H142.768C143.358 76.2253 143.836 75.915 143.836 75.5326C143.836 75.1502 143.358 74.84 142.768 74.8392H114.372Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.922 74.8392C144.833 74.84 144.761 75.1502 144.761 75.5326C144.761 75.915 144.833 76.2253 144.922 76.226H149.225C149.314 76.2253 149.387 75.915 149.387 75.5326C149.387 75.1502 149.314 74.84 149.225 74.8392H144.922Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M150.684 74.8392C150.478 74.84 150.312 75.1502 150.312 75.5326C150.312 75.915 150.478 76.2253 150.684 76.226H160.58C160.785 76.2253 160.952 75.915 160.952 75.5326C160.952 75.1502 160.785 74.84 160.58 74.8392H150.684Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M115.038 79.4617C114.591 79.4624 114.229 79.7726 114.229 80.1551C114.229 80.5375 114.591 80.8477 115.038 80.8484H136.55C136.997 80.8477 137.359 80.5375 137.359 80.1551C137.359 79.7726 136.997 79.4624 136.55 79.4617H115.038Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M102.59 79.4617C102.375 79.4624 102.202 79.7726 102.202 80.1551C102.202 80.5375 102.375 80.8477 102.59 80.8484H112.916C113.13 80.8477 113.304 80.5375 113.304 80.1551C113.304 79.7726 113.13 79.4624 112.916 79.4617H102.59Z",
  fill: "url(#paint3_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M94.9492 87.7821C94.1 87.7828 93.4124 88.093 93.4124 88.4754C93.4124 88.8579 94.1 89.1681 94.9492 89.1688H135.822C136.672 89.1681 137.359 88.8579 137.359 88.4754C137.359 88.093 136.672 87.7828 135.822 87.7821H94.9492Z",
  fill: "url(#paint4_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M98.6046 84.0841C98.2917 84.0848 98.0384 84.3951 98.0384 84.7775C98.0384 85.1599 98.2917 85.4701 98.6046 85.4709H113.663C113.976 85.4701 114.229 85.1599 114.229 84.7775C114.229 84.3951 113.976 84.0848 113.663 84.0841H98.6046Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M139.077 79.4617C138.639 79.4624 138.284 79.7726 138.284 80.1551C138.284 80.5375 138.639 80.8477 139.077 80.8484H160.159C160.597 80.8477 160.952 80.5375 160.952 80.1551C160.952 79.7726 160.597 79.4624 160.159 79.4617H139.077Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.5645 70.2168C93.2248 70.2175 92.9498 70.5277 92.9498 70.9102C92.9498 71.2926 93.2248 71.6028 93.5645 71.6035H109.914C110.253 71.6028 110.528 71.2926 110.528 70.9102C110.528 70.5277 110.253 70.2175 109.914 70.2168H93.5645Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M107.297 45.2556C107.038 45.2563 106.828 45.5666 106.828 45.949C106.828 46.3314 107.038 46.6416 107.297 46.6423H119.774C120.033 46.6416 120.243 46.3314 120.243 45.949C120.243 45.5666 120.033 45.2563 119.774 45.2556H107.297Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.462 49.8781C138.364 49.8788 138.284 50.189 138.284 50.5714C138.284 50.9538 138.364 51.2641 138.462 51.2648H143.195C143.293 51.2641 143.373 50.9538 143.373 50.5714C143.373 50.189 143.293 49.8788 143.195 49.8781H138.462Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.9386 45.2556C88.599 45.2563 88.3239 45.5666 88.3239 45.949C88.3239 46.3314 88.599 46.6416 88.9386 46.6423H105.288C105.628 46.6416 105.903 46.3314 105.903 45.949C105.903 45.5666 105.628 45.2563 105.288 45.2556H88.9386Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.0387 49.8781C89.0911 49.8788 88.3239 50.189 88.3239 50.5714C88.3239 50.9538 89.0911 51.2641 90.0387 51.2648H135.644C136.592 51.2641 137.359 50.9538 137.359 50.5714C137.359 50.189 136.592 49.8788 135.644 49.8781H90.0387Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M89.3916 54.5005C88.8016 54.5012 88.3239 54.8114 88.3239 55.1939C88.3239 55.5763 88.8016 55.8865 89.3916 55.8872H117.788C118.378 55.8865 118.855 55.5763 118.855 55.1939C118.855 54.8114 118.378 54.5012 117.788 54.5005H89.3916Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.945 49.8781C144.588 49.8788 144.298 50.189 144.298 50.5714C144.298 50.9538 144.588 51.2641 144.945 51.2648H162.155C162.512 51.2641 162.802 50.9538 162.802 50.5714C162.802 50.189 162.512 49.8788 162.155 49.8781H144.945Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M80.5406 39.7087C80.4959 39.7099 80.4597 40.2269 80.4597 40.8643C80.4597 41.5017 80.4959 42.0187 80.5406 42.0199H82.6918C82.7365 42.0187 82.7727 41.5017 82.7727 40.8643C82.7727 40.2269 82.7365 39.7099 82.6918 39.7087H80.5406Z",
  fill: "#466089"
}));

var _ref34 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip8)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.4602 72.7935H58.0994L57.8283 72.4714C57.8202 72.4617 57.8081 72.4562 57.7954 72.4566H56.7004C56.5364 72.4582 56.4045 72.5916 56.4047 72.7554V74.7252C56.4047 74.8889 56.5366 75.022 56.7004 75.0236H59.4602C59.624 75.022 59.7559 74.8889 59.7559 74.7252V73.0919C59.7559 72.9282 59.624 72.7951 59.4602 72.7935Z",
  fill: "#97A6BC"
}));

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M60.966 73.4053C60.6677 73.4056 60.4262 73.5554 60.4262 73.7401C60.4262 73.9248 60.6677 74.0747 60.966 74.075H67.4298C67.7281 74.0747 67.9696 73.9248 67.9696 73.7401C67.9696 73.5554 67.7281 73.4056 67.4298 73.4053H60.966Z",
  fill: "#97A6BC"
});

var _ref36 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip9)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.4602 77.4159H58.0994L57.8283 77.0939C57.8202 77.0841 57.8081 77.0787 57.7954 77.0791H56.7004C56.5364 77.0807 56.4045 77.214 56.4047 77.3778V79.3477C56.4047 79.5114 56.5366 79.6445 56.7004 79.6461H59.4602C59.624 79.6445 59.7559 79.5114 59.7559 79.3477V77.7144C59.7559 77.5507 59.624 77.4176 59.4602 77.4159Z",
  fill: "#97A6BC"
}));

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M60.966 78.0277C60.6677 78.0281 60.4262 78.1779 60.4262 78.3626C60.4262 78.5473 60.6677 78.6971 60.966 78.6975H67.4298C67.7281 78.6971 67.9696 78.5473 67.9696 78.3626C67.9696 78.1779 67.7281 78.0281 67.4298 78.0277H60.966Z",
  fill: "#97A6BC"
});

var _ref38 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip10)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.4602 82.0384H58.0994L57.8283 81.7163C57.8202 81.7066 57.8081 81.7011 57.7954 81.7015H56.7004C56.5364 81.7032 56.4045 81.8365 56.4047 82.0003V83.9701C56.4047 84.1338 56.5366 84.2669 56.7004 84.2686H59.4602C59.624 84.2669 59.7559 84.1338 59.7559 83.9701V82.3368C59.7559 82.1731 59.624 82.04 59.4602 82.0384Z",
  fill: "#97A6BC"
}));

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M60.966 82.6502C60.6677 82.6505 60.4262 82.8003 60.4262 82.985C60.4262 83.1697 60.6677 83.3196 60.966 83.3199H67.4298C67.7281 83.3196 67.9696 83.1697 67.9696 82.985C67.9696 82.8003 67.7281 82.6505 67.4298 82.6502H60.966Z",
  fill: "#97A6BC"
});

var _ref40 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip11)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M59.4602 86.6608H58.0994L57.8283 86.3388C57.8202 86.3291 57.8081 86.3236 57.7954 86.324H56.7004C56.5364 86.3256 56.4045 86.459 56.4047 86.6228V88.5926C56.4047 88.7563 56.5366 88.8894 56.7004 88.891H59.4602C59.624 88.8894 59.7559 88.7563 59.7559 88.5926V86.9593C59.7559 86.7956 59.624 86.6625 59.4602 86.6608Z",
  fill: "#97A6BC"
}));

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M60.966 87.2726C60.6677 87.2729 60.4262 87.4228 60.4262 87.6075C60.4262 87.7922 60.6677 87.942 60.966 87.9423H67.4298C67.7281 87.942 67.9696 87.7922 67.9696 87.6075C67.9696 87.4228 67.7281 87.2729 67.4298 87.2726H60.966Z",
  fill: "#97A6BC"
});

var _ref42 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip12)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61.7732 68.171H60.4123L60.1413 67.849C60.1332 67.8393 60.121 67.8338 60.1084 67.8342H59.0133C58.8494 67.8358 58.7174 67.9692 58.7176 68.133V70.1028C58.7176 70.2665 58.8495 70.3996 59.0133 70.4012H61.7732C61.937 70.3996 62.0689 70.2665 62.0689 70.1028V68.4695C62.0689 68.3058 61.937 68.1727 61.7732 68.171Z",
  fill: "#97A6BC"
}));

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M63.279 68.7828C62.9807 68.7832 62.7392 68.933 62.7392 69.1177C62.7392 69.3024 62.9807 69.4522 63.279 69.4526H69.7428C70.0411 69.4522 70.2826 69.3024 70.2826 69.1177C70.2826 68.933 70.0411 68.7832 69.7428 68.7828H63.279Z",
  fill: "#97A6BC"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M107.754 105.011C109.479 105.011 110.878 103.613 110.878 101.889C110.878 100.165 109.479 98.7677 107.754 98.7677C106.029 98.7677 104.63 100.165 104.63 101.889C104.63 103.613 106.029 105.011 107.754 105.011Z",
  fill: "#06172D"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M107.754 105.011C109.479 105.011 110.878 103.613 110.878 101.889C110.878 100.165 109.479 98.7677 107.754 98.7677C106.029 98.7677 104.63 100.165 104.63 101.889C104.63 103.613 106.029 105.011 107.754 105.011Z",
  fill: "url(#paint5_linear)"
});

var _ref46 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  filter: "url(#filter2_f)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M160.507 49.6953L159.008 51.1942C155.257 54.945 153.15 60.0321 153.15 65.3364L153.15 66.5782C153.15 71.8825 155.257 76.9696 159.008 80.7203L160.507 82.2193C168.317 90.0298 180.98 90.0298 188.791 82.2193L190.29 80.7203C194.041 76.9696 196.148 71.8825 196.148 66.5782L196.148 65.3364C196.148 60.0321 194.041 54.945 190.29 51.1943L188.791 49.6953C180.98 41.8848 168.317 41.8848 160.507 49.6953Z",
  fill: "#718EF7"
}));

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M162.826 40.5721L161.326 42.0706C157.574 45.8199 155.466 50.905 155.466 56.2073L155.466 57.4486C155.466 62.751 157.574 67.8361 161.326 71.5854L162.826 73.0838C170.639 80.8913 183.307 80.8913 191.121 73.0838L192.62 71.5854C196.373 67.8361 198.481 62.7509 198.481 57.4486L198.481 56.2073C198.481 50.905 196.373 45.8199 192.62 42.0706L191.121 40.5721C183.307 32.7646 170.639 32.7646 162.826 40.5721Z",
  fill: "#718EF7"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M177.163 59.8048C177.163 59.8862 177.226 59.9527 177.302 59.9527H180.725C180.801 59.9527 180.864 59.8862 180.864 59.8048V58.9173C180.864 58.836 180.801 58.7694 180.725 58.7694H177.302C177.226 58.7694 177.163 58.836 177.163 58.9173V59.8048ZM173.557 59.9176L177.109 56.9408C177.18 56.8816 177.18 56.7725 177.109 56.7133L173.557 53.7383C173.535 53.7201 173.509 53.7084 173.481 53.7046C173.453 53.7009 173.425 53.7052 173.399 53.7171C173.374 53.7289 173.352 53.7479 173.337 53.7716C173.322 53.7954 173.314 53.823 173.314 53.8511V55.0104C173.314 55.0548 173.333 55.0955 173.368 55.1232L175.4 56.828L173.368 58.5327C173.351 58.5466 173.338 58.5638 173.329 58.5833C173.32 58.6027 173.315 58.624 173.314 58.6455V59.8048C173.314 59.9306 173.46 59.999 173.557 59.9176ZM183.899 49.4321H170.28C169.952 49.4321 169.688 49.6965 169.688 50.0237V63.6322C169.688 63.9595 169.952 64.2239 170.28 64.2239H183.899C184.226 64.2239 184.491 63.9595 184.491 63.6322V50.0237C184.491 49.6965 184.226 49.4321 183.899 49.4321ZM183.158 62.8926H171.02V50.7633H183.158V62.8926Z",
  fill: "white"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M214.198 75.7637H124.157C122.834 75.7637 121.761 76.8317 121.761 78.1492V132.817H216.593V78.1492C216.593 77.5165 216.341 76.9098 215.892 76.4624C215.442 76.0151 214.833 75.7637 214.198 75.7637H214.198Z",
  fill: "#C6D7EE"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M219.908 132.62H118.447C116.956 132.62 115.747 132.706 115.747 132.813V132.813C115.747 135.259 117.73 137.242 120.176 137.242H218.178C220.624 137.242 222.607 135.259 222.607 132.813V132.813C222.607 132.762 222.323 132.713 221.816 132.676C221.31 132.64 220.624 132.62 219.908 132.62H219.908Z",
  fill: "#C6D7EE"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M214.697 77.5846H123.948V131.847H214.697V77.5846Z",
  fill: "white"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M209.204 83.4086H160.721V120.516H209.204V83.4086Z",
  fill: "#DFEAF8"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M209.401 80.8484H160.721V83.4086H209.401V80.8484Z",
  fill: "url(#paint6_linear)"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  d: "M162.455 82.6099C162.706 82.6099 162.909 82.4066 162.909 82.1559C162.909 81.9051 162.706 81.7018 162.455 81.7018C162.204 81.7018 162.001 81.9051 162.001 82.1559C162.001 82.4066 162.204 82.6099 162.455 82.6099Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  d: "M163.97 82.6099C164.221 82.6099 164.424 82.4066 164.424 82.1559C164.424 81.9051 164.221 81.7018 163.97 81.7018C163.72 81.7018 163.516 81.9051 163.516 82.1559C163.516 82.4066 163.72 82.6099 163.97 82.6099Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M165.485 82.6099C165.736 82.6099 165.939 82.4066 165.939 82.1559C165.939 81.9051 165.736 81.7018 165.485 81.7018C165.234 81.7018 165.031 81.9051 165.031 82.1559C165.031 82.4066 165.234 82.6099 165.485 82.6099Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref57 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M164.185 86.2432C163.981 86.2436 163.815 86.4165 163.815 86.6297C163.815 86.8429 163.981 87.0159 164.185 87.0163H174.019C174.223 87.0159 174.389 86.8429 174.389 86.6297C174.389 86.4165 174.223 86.2436 174.019 86.2432H164.185Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.054 85.9855C162.029 85.9862 162.009 86.2744 162.009 86.6298C162.009 86.9851 162.029 87.2733 162.054 87.274H163.253C163.278 87.2733 163.298 86.9851 163.298 86.6298C163.298 86.2744 163.278 85.9862 163.253 85.9855H162.054Z",
  fill: "#466089"
}));

var _ref58 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M164.158 89.0778C163.969 89.0782 163.815 89.2512 163.815 89.4644C163.815 89.6776 163.969 89.8505 164.158 89.8509H173.272C173.462 89.8505 173.615 89.6776 173.615 89.4644C173.615 89.2512 173.462 89.0782 173.272 89.0778H164.158Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.699 89.0778C174.385 89.0782 174.131 89.2512 174.131 89.4644C174.131 89.6776 174.385 89.8505 174.699 89.8509H189.81C190.124 89.8505 190.378 89.6776 190.378 89.4644C190.378 89.2512 190.124 89.0782 189.81 89.0778H174.699Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M191.209 89.0778C191.035 89.0782 190.894 89.2512 190.894 89.4644C190.894 89.6776 191.035 89.8505 191.209 89.8509H199.604C199.778 89.8505 199.92 89.6776 199.92 89.4644C199.92 89.2512 199.778 89.0782 199.604 89.0778H191.209Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.697 89.0778C200.552 89.0782 200.435 89.2512 200.435 89.4644C200.435 89.6776 200.552 89.8505 200.697 89.8509H207.653C207.797 89.8505 207.914 89.6776 207.914 89.4644C207.914 89.2512 207.797 89.0782 207.653 89.0778H200.697Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.054 88.5624C162.029 88.5631 162.009 88.8513 162.009 89.2067C162.009 89.562 162.029 89.8502 162.054 89.8509H163.253C163.278 89.8502 163.298 89.562 163.298 89.2067C163.298 88.8513 163.278 88.5631 163.253 88.5624H162.054Z",
  fill: "#466089"
}));

var _ref59 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M166.737 91.6547C166.548 91.6551 166.394 91.828 166.394 92.0412C166.394 92.2544 166.548 92.4274 166.737 92.4278H175.851C176.041 92.4274 176.194 92.2544 176.194 92.0412C176.194 91.828 176.041 91.6551 175.851 91.6547H166.737Z",
  fill: "url(#paint7_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.737 102.478C166.548 102.478 166.394 102.651 166.394 102.864C166.394 103.077 166.548 103.25 166.737 103.251H175.851C176.041 103.25 176.194 103.077 176.194 102.864C176.194 102.651 176.041 102.478 175.851 102.478H166.737Z",
  fill: "url(#paint8_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.674 105.57C166.519 105.57 166.394 105.743 166.394 105.957C166.394 106.17 166.519 106.343 166.674 106.343H174.109C174.264 106.343 174.389 106.17 174.389 105.957C174.389 105.743 174.264 105.57 174.109 105.57H166.674Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M175.473 105.57C175.159 105.57 174.905 105.743 174.905 105.957C174.905 106.17 175.159 106.343 175.473 106.343H190.583C190.897 106.343 191.151 106.17 191.151 105.957C191.151 105.743 190.897 105.57 190.583 105.57H175.473Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M179.442 108.147C179.357 108.147 179.289 108.32 179.289 108.533C179.289 108.747 179.357 108.92 179.442 108.92H183.519C183.604 108.92 183.673 108.747 183.673 108.533C183.673 108.32 183.604 108.147 183.519 108.147H179.442Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.089 110.724C171.935 110.724 171.81 110.897 171.81 111.11C171.81 111.324 171.935 111.496 172.089 111.497H179.525C179.679 111.496 179.804 111.324 179.804 111.11C179.804 110.897 179.679 110.724 179.525 110.724H172.089Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M180.915 110.724C180.586 110.724 180.32 110.897 180.32 111.11C180.32 111.324 180.586 111.496 180.915 111.497H196.746C197.074 111.496 197.341 111.324 197.341 111.11C197.341 110.897 197.074 110.724 196.746 110.724H180.915Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.947 110.724C197.897 110.724 197.857 110.897 197.857 111.11C197.857 111.324 197.897 111.496 197.947 111.497H200.345C200.395 111.496 200.435 111.324 200.435 111.11C200.435 110.897 200.395 110.724 200.345 110.724H197.947Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M201.159 110.724C201.044 110.724 200.951 110.897 200.951 111.11C200.951 111.324 201.044 111.496 201.159 111.497H206.675C206.79 111.496 206.883 111.324 206.883 111.11C206.883 110.897 206.79 110.724 206.675 110.724H201.159Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M181.287 113.301C181.038 113.301 180.836 113.474 180.836 113.687C180.836 113.9 181.038 114.073 181.287 114.074H193.279C193.529 114.073 193.73 113.9 193.73 113.687C193.73 113.474 193.529 113.301 193.279 113.301H181.287Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.347 113.301C174.228 113.301 174.131 113.474 174.131 113.687C174.131 113.9 174.228 114.073 174.347 114.074H180.104C180.223 114.073 180.32 113.9 180.32 113.687C180.32 113.474 180.223 113.301 180.104 113.301H174.347Z",
  fill: "url(#paint9_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.088 117.939C169.614 117.94 169.231 118.112 169.231 118.326C169.231 118.539 169.614 118.712 170.088 118.712H192.874C193.347 118.712 193.73 118.539 193.73 118.326C193.73 118.112 193.347 117.94 192.874 117.939H170.088Z",
  fill: "url(#paint10_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M172.126 115.878C171.951 115.878 171.81 116.051 171.81 116.264C171.81 116.477 171.951 116.65 172.126 116.651H180.52C180.695 116.65 180.836 116.477 180.836 116.264C180.836 116.051 180.695 115.878 180.52 115.878H172.126Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.688 113.301C194.444 113.301 194.246 113.474 194.246 113.687C194.246 113.9 194.444 114.073 194.688 114.074H206.441C206.685 114.073 206.883 113.9 206.883 113.687C206.883 113.474 206.685 113.301 206.441 113.301H194.688Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M169.316 108.147C169.127 108.147 168.973 108.32 168.973 108.533C168.973 108.747 169.127 108.92 169.316 108.92H178.43C178.62 108.92 178.773 108.747 178.773 108.533C178.773 108.32 178.62 108.147 178.43 108.147H169.316Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M176.971 94.2316C176.827 94.232 176.71 94.4049 176.71 94.6181C176.71 94.8313 176.827 95.0043 176.971 95.0047H183.927C184.071 95.0043 184.189 94.8313 184.189 94.6181C184.189 94.4049 184.071 94.232 183.927 94.2316H176.971Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M194.345 96.8086C194.291 96.809 194.246 96.9819 194.246 97.1951C194.246 97.4083 194.291 97.5812 194.345 97.5816H196.984C197.039 97.5812 197.083 97.4083 197.083 97.1951C197.083 96.9819 197.039 96.809 196.984 96.8086H194.345Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.737 94.2316C166.548 94.232 166.394 94.4049 166.394 94.6181C166.394 94.8313 166.548 95.0043 166.737 95.0047H175.851C176.041 95.0043 176.194 94.8313 176.194 94.6181C176.194 94.4049 176.041 94.232 175.851 94.2316H166.737Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.35 96.8086C166.822 96.809 166.394 96.9819 166.394 97.1951C166.394 97.4083 166.822 97.5812 167.35 97.5816H192.774C193.303 97.5812 193.73 97.4083 193.73 97.1951C193.73 96.9819 193.303 96.809 192.774 96.8086H167.35Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M166.99 99.3854C166.661 99.3858 166.394 99.5588 166.394 99.772C166.394 99.9852 166.661 100.158 166.99 100.159H182.82C183.149 100.158 183.415 99.9852 183.415 99.772C183.415 99.5588 183.149 99.3858 182.82 99.3854H166.99Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M197.959 96.8086C197.76 96.809 197.599 96.9819 197.599 97.1951C197.599 97.4083 197.76 97.5812 197.959 97.5816H207.553C207.753 97.5812 207.914 97.4083 207.914 97.1951C207.914 96.9819 207.753 96.809 207.553 96.8086H197.959Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M162.054 91.1393C162.029 91.14 162.009 91.4282 162.009 91.7836C162.009 92.1389 162.029 92.4271 162.054 92.4278H163.253C163.278 92.4271 163.298 92.1389 163.298 91.7836C163.298 91.4282 163.278 91.14 163.253 91.1393H162.054Z",
  fill: "#466089"
}));

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M182.488 89.7674H132.098V128.334H182.488V89.7674Z",
  fill: "#DFEAF8"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M182.694 87.1065H132.098V89.7674H182.694V87.1065Z",
  fill: "url(#paint11_linear)"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M133.902 88.9372C134.162 88.9372 134.374 88.7259 134.374 88.4653C134.374 88.2047 134.162 87.9935 133.902 87.9935C133.641 87.9935 133.43 88.2047 133.43 88.4653C133.43 88.7259 133.641 88.9372 133.902 88.9372Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M135.476 88.9372C135.736 88.9372 135.948 88.7259 135.948 88.4653C135.948 88.2047 135.736 87.9935 135.476 87.9935C135.215 87.9935 135.004 88.2047 135.004 88.4653C135.004 88.7259 135.215 88.9372 135.476 88.9372Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M137.05 88.9372C137.31 88.9372 137.522 88.7259 137.522 88.4653C137.522 88.2047 137.31 87.9935 137.05 87.9935C136.789 87.9935 136.578 88.2047 136.578 88.4653C136.578 88.7259 136.789 88.9372 137.05 88.9372Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref65 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M135.699 92.7135C135.487 92.7139 135.315 92.8936 135.315 93.1152C135.315 93.3368 135.487 93.5165 135.699 93.517H145.92C146.132 93.5165 146.304 93.3368 146.304 93.1152C146.304 92.8936 146.132 92.7139 145.92 92.7135H135.699Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.485 92.4457C133.46 92.4464 133.439 92.7459 133.439 93.1152C133.439 93.4845 133.46 93.7841 133.485 93.7848H134.732C134.758 93.7841 134.779 93.4845 134.779 93.1152C134.779 92.7459 134.758 92.4464 134.732 92.4457H133.485Z",
  fill: "#466089"
}));

var _ref66 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M135.671 95.6596C135.474 95.66 135.315 95.8398 135.315 96.0613C135.315 96.2829 135.474 96.4627 135.671 96.4631H145.144C145.341 96.4627 145.5 96.2829 145.5 96.0613C145.5 95.8398 145.341 95.66 145.144 95.6596H135.671Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.627 95.6596C146.3 95.66 146.036 95.8398 146.036 96.0613C146.036 96.2829 146.3 96.4627 146.627 96.4631H162.332C162.658 96.4627 162.922 96.2829 162.922 96.0613C162.922 95.8398 162.658 95.66 162.332 95.6596H146.627Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M163.786 95.6596C163.605 95.66 163.458 95.8398 163.458 96.0613C163.458 96.2829 163.605 96.4627 163.786 96.4631H172.511C172.692 96.4627 172.839 96.2829 172.839 96.0613C172.839 95.8398 172.692 95.66 172.511 95.6596H163.786Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M173.647 95.6596C173.497 95.66 173.375 95.8398 173.375 96.0613C173.375 96.2829 173.497 96.4627 173.647 96.4631H180.876C181.026 96.4627 181.148 96.2829 181.148 96.0613C181.148 95.8398 181.026 95.66 180.876 95.6596H173.647Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.485 95.1239C133.46 95.1246 133.439 95.4242 133.439 95.7935C133.439 96.1628 133.46 96.4624 133.485 96.4631H134.732C134.758 96.4624 134.779 96.1628 134.779 95.7935C134.779 95.4242 134.758 95.1246 134.732 95.1239H133.485Z",
  fill: "#466089"
}));

var _ref67 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M138.351 98.3379C138.154 98.3383 137.995 98.518 137.995 98.7396C137.995 98.9612 138.154 99.1409 138.351 99.1413H147.824C148.021 99.1409 148.18 98.9612 148.18 98.7396C148.18 98.518 148.021 98.3383 147.824 98.3379H138.351Z",
  fill: "url(#paint12_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.351 109.587C138.154 109.587 137.995 109.767 137.995 109.988C137.995 110.21 138.154 110.39 138.351 110.39H147.824C148.021 110.39 148.18 110.21 148.18 109.988C148.18 109.767 148.021 109.587 147.824 109.587H138.351Z",
  fill: "url(#paint13_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.286 112.801C138.125 112.801 137.995 112.981 137.995 113.202C137.995 113.424 138.125 113.604 138.286 113.604H146.013C146.174 113.604 146.304 113.424 146.304 113.202C146.304 112.981 146.174 112.801 146.013 112.801H138.286Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M147.431 112.801C147.104 112.801 146.84 112.981 146.84 113.202C146.84 113.424 147.104 113.604 147.431 113.604H163.136C163.462 113.604 163.726 113.424 163.726 113.202C163.726 112.981 163.462 112.801 163.136 112.801H147.431Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.556 115.479C151.468 115.479 151.397 115.659 151.397 115.881C151.397 116.102 151.468 116.282 151.556 116.282H155.794C155.882 116.282 155.953 116.102 155.953 115.881C155.953 115.659 155.882 115.479 155.794 115.479H151.556Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.914 118.157C143.754 118.157 143.624 118.337 143.624 118.559C143.624 118.78 143.754 118.96 143.914 118.961H151.642C151.803 118.96 151.933 118.78 151.933 118.559C151.933 118.337 151.803 118.157 151.642 118.157H143.914Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.087 118.157C152.746 118.157 152.469 118.337 152.469 118.559C152.469 118.78 152.746 118.96 153.087 118.961H169.54C169.882 118.96 170.159 118.78 170.159 118.559C170.159 118.337 169.882 118.157 169.54 118.157H153.087Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.789 118.157C170.737 118.157 170.695 118.337 170.695 118.559C170.695 118.78 170.737 118.96 170.789 118.961H173.282C173.333 118.96 173.375 118.78 173.375 118.559C173.375 118.337 173.333 118.157 173.282 118.157H170.789Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M174.127 118.157C174.008 118.157 173.911 118.337 173.911 118.559C173.911 118.78 174.008 118.96 174.127 118.961H179.86C179.98 118.96 180.076 118.78 180.076 118.559C180.076 118.337 179.98 118.157 179.86 118.157H174.127Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.473 120.835C153.214 120.836 153.005 121.015 153.005 121.237C153.005 121.459 153.214 121.638 153.473 121.639H165.938C166.197 121.638 166.406 121.459 166.406 121.237C166.406 121.015 166.197 120.836 165.938 120.835H153.473Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M146.261 120.835C146.137 120.836 146.036 121.015 146.036 121.237C146.036 121.459 146.137 121.638 146.261 121.639H152.244C152.368 121.638 152.469 121.459 152.469 121.237C152.469 121.015 152.368 120.836 152.244 120.835H146.261Z",
  fill: "url(#paint14_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.834 125.656C141.342 125.657 140.943 125.836 140.943 126.058C140.943 126.28 141.342 126.459 141.834 126.46H165.516C166.008 126.459 166.406 126.28 166.406 126.058C166.406 125.836 166.008 125.657 165.516 125.656H141.834Z",
  fill: "url(#paint15_linear)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M143.952 123.514C143.77 123.514 143.624 123.694 143.624 123.915C143.624 124.137 143.77 124.317 143.952 124.317H152.677C152.858 124.317 153.005 124.137 153.005 123.915C153.005 123.694 152.858 123.514 152.677 123.514H143.952Z",
  fill: "#E9EFFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.402 120.835C167.148 120.836 166.942 121.015 166.942 121.237C166.942 121.459 167.148 121.638 167.402 121.639H179.617C179.87 121.638 180.076 121.459 180.076 121.237C180.076 121.015 179.87 120.836 179.617 120.835H167.402Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.032 115.479C140.835 115.479 140.675 115.659 140.675 115.881C140.675 116.102 140.835 116.282 141.032 116.282H150.504C150.701 116.282 150.861 116.102 150.861 115.881C150.861 115.659 150.701 115.479 150.504 115.479H141.032Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M148.988 101.016C148.838 101.017 148.716 101.196 148.716 101.418C148.716 101.639 148.838 101.819 148.988 101.82H156.217C156.368 101.819 156.489 101.639 156.489 101.418C156.489 101.196 156.368 101.017 156.217 101.016H148.988Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M167.046 103.694C166.989 103.695 166.942 103.875 166.942 104.096C166.942 104.318 166.989 104.498 167.046 104.498H169.788C169.845 104.498 169.891 104.318 169.891 104.096C169.891 103.875 169.845 103.695 169.788 103.694H167.046Z",
  fill: "#899BD9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.351 101.016C138.154 101.017 137.995 101.196 137.995 101.418C137.995 101.639 138.154 101.819 138.351 101.82H147.824C148.021 101.819 148.18 101.639 148.18 101.418C148.18 101.196 148.021 101.017 147.824 101.016H138.351Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.989 103.694C138.44 103.695 137.995 103.875 137.995 104.096C137.995 104.318 138.44 104.498 138.989 104.498H165.413C165.962 104.498 166.406 104.318 166.406 104.096C166.406 103.875 165.962 103.695 165.413 103.694H138.989Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.614 106.373C138.272 106.373 137.995 106.553 137.995 106.774C137.995 106.996 138.272 107.176 138.614 107.176H155.066C155.408 107.176 155.685 106.996 155.685 106.774C155.685 106.553 155.408 106.373 155.066 106.373H138.614Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M170.802 103.694C170.595 103.695 170.427 103.875 170.427 104.096C170.427 104.318 170.595 104.498 170.802 104.498H180.773C180.98 104.498 181.148 104.318 181.148 104.096C181.148 103.875 180.98 103.695 180.773 103.694H170.802Z",
  fill: "#466089"
}), /*#__PURE__*/React.createElement("path", {
  d: "M133.485 97.8022C133.46 97.8029 133.439 98.1025 133.439 98.4718C133.439 98.8411 133.46 99.1407 133.485 99.1414H134.732C134.758 99.1407 134.779 98.8411 134.779 98.4718C134.779 98.1025 134.758 97.8029 134.732 97.8022H133.485Z",
  fill: "#466089"
}));

var _ref68 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.2,
  filter: "url(#filter3_f)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 115.551,
  cy: 133.305,
  rx: 17.9025,
  ry: 17.8889,
  fill: "#EA73AB"
}));

var _ref69 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 119.529,
  cy: 129.33,
  rx: 17.9025,
  ry: 17.8889,
  fill: "#EA73AB"
});

var _ref70 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip13)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M125.923 124.219H116.589C116.518 124.219 116.461 124.277 116.461 124.347V125.242C116.461 125.312 116.518 125.369 116.589 125.369H125.923C125.994 125.369 126.051 125.312 126.051 125.242V124.347C126.051 124.277 125.994 124.219 125.923 124.219ZM125.923 128.756H116.589C116.518 128.756 116.461 128.813 116.461 128.883V129.778C116.461 129.848 116.518 129.906 116.589 129.906H125.923C125.994 129.906 126.051 129.848 126.051 129.778V128.883C126.051 128.813 125.994 128.756 125.923 128.756ZM125.923 133.292H116.589C116.518 133.292 116.461 133.349 116.461 133.419V134.314C116.461 134.384 116.518 134.442 116.589 134.442H125.923C125.994 134.442 126.051 134.384 126.051 134.314V133.419C126.051 133.349 125.994 133.292 125.923 133.292ZM113.008 124.794C113.008 124.912 113.031 125.028 113.076 125.137C113.121 125.245 113.187 125.344 113.27 125.427C113.353 125.51 113.452 125.576 113.561 125.621C113.669 125.666 113.786 125.689 113.903 125.689C114.021 125.689 114.137 125.666 114.246 125.621C114.354 125.576 114.453 125.51 114.536 125.427C114.619 125.344 114.685 125.245 114.73 125.137C114.775 125.028 114.798 124.912 114.798 124.794C114.798 124.677 114.775 124.561 114.73 124.452C114.685 124.344 114.619 124.245 114.536 124.162C114.453 124.079 114.354 124.013 114.246 123.968C114.137 123.923 114.021 123.9 113.903 123.9C113.786 123.9 113.669 123.923 113.561 123.968C113.452 124.013 113.353 124.079 113.27 124.162C113.187 124.245 113.121 124.344 113.076 124.452C113.031 124.561 113.008 124.677 113.008 124.794V124.794ZM113.008 129.331C113.008 129.448 113.031 129.564 113.076 129.673C113.121 129.781 113.187 129.88 113.27 129.963C113.353 130.046 113.452 130.112 113.561 130.157C113.669 130.202 113.786 130.225 113.903 130.225C114.021 130.225 114.137 130.202 114.246 130.157C114.354 130.112 114.453 130.046 114.536 129.963C114.619 129.88 114.685 129.781 114.73 129.673C114.775 129.564 114.798 129.448 114.798 129.331C114.798 129.213 114.775 129.097 114.73 128.988C114.685 128.88 114.619 128.781 114.536 128.698C114.453 128.615 114.354 128.549 114.246 128.504C114.137 128.459 114.021 128.436 113.903 128.436C113.786 128.436 113.669 128.459 113.561 128.504C113.452 128.549 113.353 128.615 113.27 128.698C113.187 128.781 113.121 128.88 113.076 128.988C113.031 129.097 113.008 129.213 113.008 129.331V129.331ZM113.008 133.867C113.008 133.984 113.031 134.1 113.076 134.209C113.121 134.318 113.187 134.416 113.27 134.499C113.353 134.582 113.452 134.648 113.561 134.693C113.669 134.738 113.786 134.761 113.903 134.761C114.021 134.761 114.137 134.738 114.246 134.693C114.354 134.648 114.453 134.582 114.536 134.499C114.619 134.416 114.685 134.318 114.73 134.209C114.775 134.1 114.798 133.984 114.798 133.867C114.798 133.749 114.775 133.633 114.73 133.524C114.685 133.416 114.619 133.317 114.536 133.234C114.453 133.151 114.354 133.085 114.246 133.04C114.137 132.995 114.021 132.972 113.903 132.972C113.786 132.972 113.669 132.995 113.561 133.04C113.452 133.085 113.353 133.151 113.27 133.234C113.187 133.317 113.121 133.416 113.076 133.524C113.031 133.633 113.008 133.749 113.008 133.867V133.867Z",
  fill: "white"
}));

var _ref71 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1,
  filter: "url(#filter4_f)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 49.7255,
  cy: 141.336,
  rx: 39.5782,
  ry: 39.548,
  fill: "#3B82FF"
}));

var _ref72 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 58.8501,
  cy: 132.548,
  rx: 39.5782,
  ry: 39.548,
  fill: "#3B82FF"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M43.3259 135.33V130.267H56.5016V117.036H61.6692V130.267H74.8449V135.33H61.6692V148.531H56.5016V135.33H43.3259Z",
  fill: "white"
});

var _ref74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_f",
  x: 29.9243,
  y: 18.5154,
  width: 151.427,
  height: 107.989,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_f",
  x: 26.8989,
  y: 77.4552,
  width: 160.715,
  height: 54.5989,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 10,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_f",
  x: 143.15,
  y: 33.8374,
  width: 62.998,
  height: 64.2398,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_f",
  x: 87.6484,
  y: 105.416,
  width: 55.805,
  height: 55.7777,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_f",
  x: 0.147278,
  y: 91.7884,
  width: 99.1564,
  height: 99.0961,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "BackgroundImageFix",
  result: "shape"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 5,
  result: "effect1_foregroundBlur"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 272.413,
  y1: -16.1619,
  x2: 181.646,
  y2: 205.061,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#C5D3F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C5D3F5",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 88.3239,
  y1: 41.3265,
  x2: 105.903,
  y2: 41.3265,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 88.3239,
  y1: 60.7408,
  x2: 105.903,
  y2: 60.7408,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 102.202,
  y1: 80.155,
  x2: 113.304,
  y2: 80.155,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 93.4124,
  y1: 88.4754,
  x2: 137.359,
  y2: 88.4754,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 106.096,
  y1: 99.6646,
  x2: 110.694,
  y2: 101.413,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#199DEC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6EC7FC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 160.721,
  y1: 82.1285,
  x2: 221.145,
  y2: 82.1285,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7485C5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DFEAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 166.394,
  y1: 92.0412,
  x2: 176.194,
  y2: 92.0412,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 166.394,
  y1: 102.864,
  x2: 176.194,
  y2: 102.864,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 174.131,
  y1: 113.687,
  x2: 180.32,
  y2: 113.687,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 169.231,
  y1: 118.326,
  x2: 193.73,
  y2: 118.326,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 132.098,
  y1: 88.4369,
  x2: 194.899,
  y2: 88.4369,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#BF5E93"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#DFEAF8"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 137.995,
  y1: 98.7396,
  x2: 148.18,
  y2: 98.7396,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 137.995,
  y1: 109.988,
  x2: 148.18,
  y2: 109.988,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 146.036,
  y1: 121.237,
  x2: 152.469,
  y2: 121.237,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 140.943,
  y1: 126.058,
  x2: 166.406,
  y2: 126.058,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#9D7DA8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C06496"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(56.4047 35.0862)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip1"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(56.4047 30.4638)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip2"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(58.7176 39.7087)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip3"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(61.0306 44.3311)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip4"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(61.0306 48.9536)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip5"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(61.0306 53.576)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip6"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(61.0306 58.1984)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip7"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(61.0306 62.8209)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip8"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(56.4047 72.0658)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip9"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(56.4047 76.6882)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip10"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(56.4047 81.3107)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip11"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(56.4047 85.9331)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip12"
}, /*#__PURE__*/React.createElement("rect", {
  width: 3.35128,
  height: 3.34872,
  fill: "white",
  transform: "translate(58.7176 67.4433)"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip13"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14.322,
  height: 14.3111,
  fill: "white",
  transform: "translate(112.368 122.174)"
})));

function SvgCreateImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 238,
    height: 191,
    viewBox: "0 0 238 191",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 107,
    width: 31,
    height: 14
  }, _ref4), _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateImg);
export default __webpack_public_path__ + "static/media/create_img.b4b4d89f.svg";
export { ForwardRef as ReactComponent };